export const NAVIGATION = 'NAVIGATION'
export const SHOW_ORDER_MANAGEMENT = 'SHOW_ORDER_MANAGEMENT'
export const SHOW_MENU = 'SHOW_MENU'
export const GET_HEIGHT = 'GET_HEIGHT'
export const HEADER_NAV = 'HEADER_NAV'
export const SET_SAVE_FUNCTION = 'SET_SAVE_FUNCTION'